var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('voicemail-drawer'),_c('voicemails',{ref:"voicemails"}),_c('voicemail-force-enable-ia-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }